import React, { useEffect, useState, useRef } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

import { Grid, InputAdornment } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search'
import moment from 'moment/moment';
import { History } from '@material-ui/icons';

import { GenericBandeja } from '../../atomic/organisms/GenericBandeja'
import { useTraslados } from '../../../hooks/useCases/useTraslados'
import { GenericTable } from '../../atomic/organisms/GenericTable';
import { DatePickerGeneric } from '../../atomic/atoms/DatePicker';
import { Buscador } from '../../atomic/molecules/Buscador';
import { InputField } from '../../atomic/atoms/Inputs';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { ButtonGeneric, IconButtonGeneric } from '../../atomic/atoms/Buttons';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { ModalAuditarTraslados } from './ModalAuditarTraslados';
import { GTab } from '../../atomic/organisms/GenericTab';
import { useSelector } from 'react-redux';
import DeleteButtonAbm from '../../compartidos/abms/DeleteButtonAbm';

const center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const initSearch = {
    fechaDesde: moment().subtract(30, 'days'),
    fechaHasta: moment(),
    idAfiliado: "",
    idPractica: "",
    idSolicitud: "",
};

const initModalHistory = {
    open: false,
    title: ''
}

const initModalAuditar = {
    open: false,
    fieldsDisabled: true,
    title: ''
}

export const BandejaTraslados = () => {
    const componentRef = useRef();
    const { data, get, clean, post, permisos, remove } = useTraslados();

    const estadoCarga = data.dim.estados[0].id;
    const estadoAuditoria = data.dim.estados[1].id;
    const estadoPendiente = data.dim.estados[2].id;

    const [search, setSearch] = useState(initSearch);
    const [openModalHistory, setOpenModalHistory] = useState(initModalHistory);
    const [openModalAuditar, setOpenModalAuditar] = useState(initModalAuditar);
    const [estado, setEstado] = useState(estadoCarga);
    const { idUsuario } = useSelector(state => state.auth);

    const [afiliado, setAfiliado] = useState(null);
    const [practica, setPractica] = useState(null);
    const [solicitud, setSolicitud] = useState("");

    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        get.solicitudes({
            ...search,
            fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        })
    }, [search]);

    const dataSearch = [
        {
            value: afiliado,
            setValue: (val) => {
                setSearch({ ...search, idAfiliado: val?.id_afiliado || "", idSolicitud: "" })
                setAfiliado(val);
                setSolicitud("");
            },
            label: "Nombre y Afiliado | Nro Doc | Nro Afiliado | CUIL",
            endpoint: (inputValue) => `Afiliados/traerPorNombreoDNIoNroAfi/${inputValue}/Todos/Todos`,
            noOptionText: "No se encuentra afiliado",
            renderOption: (option) => `${option.apellido_y_nombre} Nro Afi:${option.carnet} - CUIL:${option.cuil}`,
            getOptionLabel: (option) => `${option.apellido_y_nombre} Nro Afi:${option.carnet} - CUIL:${option.cuil}`
        },
        {
            value: practica,
            setValue: (val) => {
                setSearch({ ...search, idEfector: val?.id || "", idSolicitud: "" })
                setPractica(val);
                setSolicitud("");
            },
            label: "Código Práctica",
            endpoint: (inputValue) => `NomencladorNacional?codigoNombre=${inputValue}&todas=${true}`,
            noOptionText: "No se encuentran practicas",
            getOptionLabel: (option) => `${option.codNom}-${option.desNom}`
        },
    ];

    const dataDates = [
        { value: search.fechaDesde, onChange: (date) => { setSearch({ ...search, idSolicitud: "", fechaDesde: date }); setSolicitud(""); }, label: "Fecha Inicio" },
        { value: search.fechaHasta, onChange: (date) => { setSearch({ ...search, idSolicitud: "", fechaHasta: date }); setSolicitud(""); }, label: "Fecha Fin" },
    ];

    return (
        <div style={{ width: "100%", padding: "2em" }}>
            <GenericBandeja
                radioList={data.dim.estados.map(({ id, descripcion }) => {
                    const size = data.solicitudes.filter(x => x.idEstado === id).length
                    return { label: `${descripcion} (${size})`, value: id }
                })}
                setRadioValue={(value) => setEstado(value)}
                radioValue={estado}
                files={{
                    handlePdf: () => get.files.pdf({
                        ...search,
                        fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        idEstado: estado
                    })
                }}
                SearchComponent={[
                    {
                        gridProps: { lg: 8 },
                        Component: () => (
                            <Grid
                                container
                                justify="space-evenly"
                                style={{ backgroundColor: '#eee' }}
                            >
                                {dataSearch.map((props, index) => (
                                    <Grid key={index} item xs={12} md={4} style={{ ...center, backgroundColor: "#FFF", border: "1px solid #ccc", padding: "0.5em" }}>
                                        <Buscador
                                            ref={componentRef}
                                            variant="outlined"
                                            {...props}
                                        />
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4} style={{ ...center, backgroundColor: "#FFF", border: "1px solid #ccc", padding: "0.5em" }}>
                                    <InputField
                                        placeholder="Solicitud"
                                        onChange={(e) => setSolicitud(e.target.value)}
                                        value={solicitud}
                                        variant="outlined"
                                        type="number"
                                        endAdornment={(
                                            <InputAdornment position="end">
                                                <SearchIcon style={{ color: "#999", cursor: "pointer" }} onClick={() => setSearch({ ...search, idSolicitud: solicitud })} />
                                            </InputAdornment>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        )
                    },
                    {
                        gridProps: { lg: 4 },
                        Component: () => (
                            <Grid
                                container
                                justify="space-evenly"
                                style={{ backgroundColor: '#eee' }}
                            >
                                {dataDates.map(({ value, onChange, label }, index) => (
                                    <Grid key={index} item xs={12} md={6} style={{ ...center, backgroundColor: "#FFF", border: "1px solid #ccc", padding: "0.5em" }}>
                                        <DatePickerGeneric
                                            style={{ padding: "0 0.5em" }}
                                            value={value}
                                            label={label}
                                            onChange={onChange}
                                            fullWidth
                                            {...(index === 0) ? { maxDate: search.fechaHasta } : { minDate: search.fechaDesde }}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )
                    },
                ]}
            >
                <GenericTable
                    ref={componentRef}
                    data={data.solicitudes.filter(({ idEstado, id }) => idEstado === estado && (solicitud ? id === +solicitud : true))}
                    align="center"
                    columns={[
                        {
                            label: "Historial",
                            customBody: (item) =>
                                <IconButtonGeneric
                                    ariaLabel="historial"
                                    Icon={History}
                                    color="primary"
                                    onClick={() => {
                                        get.getTrackingSolicitud(item.id);
                                        setOpenModalHistory({
                                            open: true,
                                            title: `Historial Orden N° ${item.id}`,
                                        });
                                    }}
                                />
                        },
                        {
                            label: "Estado",
                            customBody: ({ idEstado }) => {
                                const estado = data.dim.estados.find(({ id }) => id === idEstado)
                                return (
                                    <IconEstado
                                        useColorTable
                                        texto={estado.letra}
                                        backgroundColor={estado.color}
                                        descripcion={estado.descripcion}
                                    />
                                )
                            }
                        },
                        {
                            label: "Fecha",
                            customBody: ({ fechaAlta }) => moment(fechaAlta).format("DD/MM/YYYY"),
                            sort: true
                        },
                        {
                            id: "id",
                            label: "N° Orden",
                            sort: true
                        },
                        {
                            label: "Práctica",
                            customBody: ({ practica }) => practica ? `${practica?.codNom} - ${practica?.desNom}` : ""
                        },
                        {
                            label: "Diagnostico",
                            customBody: ({ diagnostico }) => diagnostico?.problema || "No asignado"
                        },
                        {
                            label: "Médico Tratante",
                            customBody: ({ medico }) => medico?.apellidoNombre ? medico?.apellidoNombre.trim() : "No asignado"
                        },
                        {
                            label: "Efector",
                            customBody: ({ efector }) => efector?.razonSocial ? efector?.razonSocial.trim() : ""
                        },
                        {
                            label: "Paciente",
                            customBody: ({ afiliado }) => afiliado?.apellido_y_nombre ? afiliado.apellido_y_nombre.trim() : ""
                        },
                        {
                            label: "N° Afiliado",
                            customBody: ({ afiliado }) => afiliado?.carnet || ""
                        },
                        {
                            filter: estadoAuditoria !== estado && estadoPendiente !== estado,
                            label: "Tomada",
                            customBody: ({ solicitudTrasladoTomada }) => solicitudTrasladoTomada?.usuarioTomada ? solicitudTrasladoTomada?.usuarioTomada?.userName : ""
                        },
                        {
                            label: "",
                            customBody: ({ id, solicitudTrasladoTomada }) => (
                                <ButtonGeneric
                                    text={estado === estadoCarga
                                        ? "Ir"
                                        : solicitudTrasladoTomada !== null
                                            ?
                                            ((solicitudTrasladoTomada?.idUsuarioTomada === null || solicitudTrasladoTomada?.idUsuarioTomada === idUsuario) &&
                                                (estadoAuditoria === estado || estadoPendiente === estado)) || !permisos.home.auditoria.administracion
                                                ? "Auditar"
                                                : "Ver"
                                            : "Auditar"}
                                    size="small"
                                    onClick={() => {
                                        if (estado === estadoCarga) setRedirect(id);

                                        else {
                                            if (
                                                (estadoAuditoria === estado || estadoPendiente === estado) &&
                                                (solicitudTrasladoTomada?.idUsuarioTomada === null || solicitudTrasladoTomada?.idUsuarioTomada === undefined) &&
                                                permisos.home.auditoria.administracion
                                            ) post.solicitudTomada(id);

                                            get.solicitud(id, setOpenModalAuditar, idUsuario);
                                        }
                                    }}
                                />
                            )
                        },
                        ...((estado === estadoCarga || estado === estadoAuditoria)? [
                            {
                                label: "",
                                customBody: ({ id }) => (
                                    <DeleteButtonAbm
                                        permiso={null}
                                        mensajeEliminacion={"¿Desea eliminar esta solicitud?"}
                                        handleDelete={() => remove.solicitudEnCarga(id)}
                                    />
                                )
                            }
                        ] : [])

                    ]}
                />
            </GenericBandeja>

            {redirect && (
                <Redirect
                    to={{
                        pathname: '/traslados',
                        state: {
                            idSolicitud: redirect,
                        }
                    }}
                />
            )}

            {openModalHistory.open && (
                <GenericModal
                    open={openModalHistory.open}
                    closeModal={() => {
                        setOpenModalHistory(initModalHistory);
                        clean.trackingSolicitud();
                    }}
                    title={openModalHistory.title}
                >
                    <GTab
                        tabs={data.dim.tipoTracking.map(({ id, descripcion }) => ({
                            label: descripcion,
                            component: (
                                <Historial
                                    data={data.trackingSolicitud.filter(({ idTipoTracking }) => id === idTipoTracking)}
                                />
                            )
                        }))}
                    >

                    </GTab>
                </GenericModal>
            )}

            {openModalAuditar.open && (
                <GenericModal
                    open={openModalAuditar.open}
                    closeModal={() => {
                        setOpenModalAuditar(initModalAuditar);
                        clean.solicitud();
                        get.solicitudes({
                            ...search,
                            fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                            fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        });
                    }}
                    title={openModalAuditar.title}
                    gridStyle={{ textAlign: 'center', padding: '1em' }}
                    maxWidth="lg"
                >
                    <ModalAuditarTraslados
                        estadoActual={estado}
                        fieldsDisabled={openModalAuditar.fieldsDisabled}
                        handleClose={() => {
                            setOpenModalAuditar(initModalAuditar);
                            clean.solicitud();
                            get.solicitudes({
                                ...search,
                                fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                                fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                            });
                        }}
                        seguimiento={false}
                    />
                </GenericModal>
            )}
        </div>
    )
}

export const Historial = ({ data }) => {
    const componentRef = useRef();
    return (
        <TableGeneric
            ref={componentRef}
            data={data}
            align="center"
            colTitleStyle={{ fontSize: '1.2em' }}
            withoutPagination
            rowStyle={{
                fontWeight: "bold"
            }}
            columns={[
                {
                    id: 'fecha',
                    label: 'Fecha',
                    customBody: (item) => moment(item.fecha).format('DD/MM/YYYY - hh:mm'),
                },
                {
                    label: 'Campo',
                    customBody: ({ campo }) => campo.toUpperCase()
                },
                {
                    label: 'Valor Anterior',
                    customBody: ({ valorAnterior }) => <span style={{ color: "red" }}>{valorAnterior || "-"}</span>
                },
                {
                    label: 'Valor Nuevo',
                    customBody: ({ valorNuevo }) => <span style={{ color: "green" }}>{valorNuevo || "-"}</span>
                },
                {
                    label: 'Usuario',
                    customBody: ({ usuario }) => usuario?.userName
                }
            ]}
        />
    )
}
